import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center border-t border-gray-800" data-id="element-55">
      <div className="max-w-4xl mx-auto" data-id="element-56">
        <p className="font-bold text-white mb-4" data-id="element-57">
          MEGA PACK CIENCIAS SOCIALES LISTA
        </p>
        <p className="mb-4" data-id="element-58">
          © 2026 Mega Pack Ciencias Sociales Lista™. Todos los derechos
          reservados.
        </p>
        <div className="flex justify-center gap-4 text-sm" data-id="element-59">
          <span className="cursor-pointer hover:text-white" data-id="element-60">Términos</span>
          <span data-id="element-61">·</span>
          <span className="cursor-pointer hover:text-white" data-id="element-62">Privacidad</span>
          <span data-id="element-63">·</span>
          <span className="cursor-pointer hover:text-white" data-id="element-64">Soporte</span>
        </div>
      </div>
    </footer>;
}